<template>
<div> 
    <v-container style="padding: 0 12px"> 
        <v-row style="width: 100%">
            <v-col cols="6" md="3">
                <div style="float: left">
                    <v-icon>mdi-home</v-icon>
                </div>
                <div style="margin-left: 20px; background:  ">
                    <span>Cuenta:<br></span>
                    <v-skeleton-loader
                            type="paragraph"
                            :loading="loading"
                        >                    
                        <span> {{alarma.cuenta}} </span>
                    </v-skeleton-loader>
                </div>
            </v-col>
            <v-col cols="6" md="3">
                <div style="float: left">
                    <v-icon>mdi-account</v-icon>
                </div>
                <div style="margin-left: 25px; background: ">
                    <span>Cliente:<br></span>
                    <v-skeleton-loader
                            type="paragraph"
                            :loading="loading"
                        >                    
                    <span> Jhon Doe Industries </span>
                    </v-skeleton-loader>
                </div>           
            </v-col>
            <v-col cols="6" md="3">
              <div style="float: left">
                    <v-icon>mdi-alert-outline</v-icon>
                </div>
                <div style="margin-left: 30px; background: ">
                    <span>Prioridad:<br></span>
                    <v-skeleton-loader
                            type="paragraph"
                            :loading="loading"
                        >                    
                    <span> {{prioridadForItem(alarma)}} </span>
                    </v-skeleton-loader>
                </div>     
            </v-col>
            <v-col cols="6" md="3">
                <div style="float: left">
                    <v-icon>mdi-cellphone-link </v-icon>
                </div>
                <div style="margin-left: 30px; background: ">
                    <span>Origen:<br></span>
                    <v-skeleton-loader
                            type="paragraph"
                            :loading="loading"
                        >                    
                    <span> Dispositivo IoT -SP4 </span>
                    </v-skeleton-loader>
                </div>    
            </v-col>
        </v-row> 
    </v-container>
    <v-divider class="mx-4"></v-divider>
    <v-container style="padding: 0 12px"> 
        <v-row style="width: 100%">
           <v-col cols="4" md="3" >
                <div style="float: left">
                    <v-icon>mdi-calendar</v-icon>
                </div>
                <div style="margin-left: 25px; background: ">
                    <span>Fecha:<br></span>
<!--                     <span> {{ (new Date()).toLocaleString("es") }} </span>                         -->
                    <v-skeleton-loader
                            type="paragraph"
                            :loading="loading"
                        >                    
                    <span> {{ alarma.fecha | moment("YYYY-MM-DD hh:mm:ss") }} </span>
                    </v-skeleton-loader>
                </div>
            </v-col>
            <v-col cols="8" md="6" >
                <div style="float: left">
                    <v-icon>mdi-map-marker </v-icon>
                </div>
                <div style="margin-left: 25px; background: ">
                    <span>Ubicación:<br></span>
                    <v-skeleton-loader
                            type="paragraph"
                            :loading="loading"
                        >                    
                    <span> {{ alarma.ubicacion }}</span>
                    </v-skeleton-loader>
                </div>
            </v-col>
            <v-col cols="4" md="0" class="d-block d-md-none">
                
            </v-col>
            <v-col cols="8" md="3" >
                <div style="position: relative; height: 100%; ">
                    <v-btn style="position: absolute; bottom:0" depressed v-show="!loading" dense dark small color="info" @click="mapClick">Ubicación en mapa</v-btn>
                </div>
            </v-col>
        </v-row> 
    </v-container>
    <v-divider class="mx-4"></v-divider>
    <v-container style="padding: 0 12px"> 
        <v-row style="width: 100%; background: ">
            <v-col cols="12" md="5" >
                <div style="float: left">
                    <v-icon>mdi-image</v-icon>
                </div>
                <div style="margin-left: 20px; background: ">
                    <span>Imagen de cuenta:<br></span>
                    <v-skeleton-loader
                            type="image"
                            :loading="loading"
                        >                    
                    <img style="padding-top:30px; max-width:100%;max-height:100%;" src="https://upload.wikimedia.org/wikipedia/commons/1/15/Revised_Baca_House%2C_Trinidad%2C_CO_IMG_5081.JPG"></img>
                    </v-skeleton-loader>
                </div>
            </v-col>
            <v-col cols="12" md="7">
                 <v-skeleton-loader
                            type="article, date-picker-days"
                            :types="{'date-picker-days': 'avatar@2', 'paragraph': 'text@10'}"
                            :loading="loading"
                        >                    
                    <div style="background:  ">
                        <PlanReaccion />
                    </div>   

                    <div class="center" style="margin-top:10px; ">
                            <v-btn style="float:left; width: 48%"  dark color="info"> Cerrar alarma </v-btn>
                            <v-btn style="float:right; width: 48%"   dark color="info"> Transferir a Master  </v-btn>
                    </div>    
                </v-skeleton-loader>
     
            </v-col>
        </v-row> 
    </v-container>
    
</div>
</template>


<script>
import PlanReaccion from '@/components/PlanReaccion/PlanReaccion.vue'
import {AlertType, AlertStatus} from '@/views/helpers'

export default {
    name: 'ScrollableVueCard',
    components:{
        PlanReaccion
    },
    props:{
        title: String,
        loading: Boolean,
        alarma: Object
    },
    data: () => ({
        item: null,
        AlertType
    }),
    methods:{
        prioridadForItem(item){
            switch(item.tipo){
                case AlertType.BLUE: return "Media"
                case AlertType.YELLOW: return "Alta"
                case AlertType.GREEN: return "Baja"
                case AlertType.RED: return "Urgente"
            }
        },
        mapClick(){
            this.$emit('mapClick')
        }
    }
}
</script>
<style scoped> 

.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
  padding: 0;
}

.v-btn {
    text-transform:none !important;
  }

  
.center {
  text-align: center;
  margin: auto;
  margin-top: 20px;
}
</style>